// Catalogo dei campi del wizard "Nuova Pratica" che il titolare puo' rendere obbligatori.
// Condiviso tra Impostazioni Studio (selezione) e il wizard (validazione/asterischi).
export const REQUIREABLE_FIELDS = [
  { key: "data_apertura", label: "Data di Apertura", step: 1, group: "Dati Sinistro" },
  { key: "segnalatore", label: "Segnalatore Pratica", step: 1, group: "Dati Sinistro" },
  { key: "tipo", label: "Tipo Pratica", step: 1, group: "Dati Sinistro" },
  { key: "procedura_card", label: "Procedura Card", step: 1, group: "Dati Sinistro" },
  { key: "lesioni", label: "Lesioni", step: 1, group: "Dati Sinistro" },
  { key: "data_sinistro", label: "Data del Sinistro", step: 1, group: "Dati Sinistro" },
  { key: "ora_sinistro", label: "Ora Sinistro", step: 1, group: "Dati Sinistro" },
  { key: "luogo_sinistro", label: "Citta' Sinistro", step: 1, group: "Dati Sinistro" },
  { key: "luogo_provincia", label: "Provincia Sinistro", step: 1, group: "Dati Sinistro" },
  { key: "indirizzo_sinistro", label: "Indirizzo Sinistro", step: 1, group: "Dati Sinistro" },
  { key: "veicoli_coinvolti", label: "Veicoli Coinvolti nell'Urto", step: 1, group: "Dati Sinistro" },
  { key: "barem_cliente", label: "Barem Veicolo Cliente", step: 1, group: "Dati Sinistro" },
  { key: "barem_controparte", label: "Barem Veicolo Controparte", step: 1, group: "Dati Sinistro" },
  { key: "autorita_intervenute", label: "Autorita' Intervenute", step: 1, group: "Dati Sinistro" },
  { key: "cliente_presente", label: "Almeno un cliente", step: 2, group: "Clienti" },
  { key: "cliente_cf", label: "Codice Fiscale cliente", step: 2, group: "Clienti" },
  { key: "cliente_targa", label: "Targa cliente", step: 2, group: "Clienti" },
  { key: "controparte_presente", label: "Almeno una controparte", step: 3, group: "Controparte" },
  { key: "testimone_presente", label: "Almeno un testimone", step: 4, group: "Testimone" },
];

export const REQ_GROUPS = ["Dati Sinistro", "Clienti", "Controparte", "Testimone"];

// Preselezione iniziale (finche' il titolare non salva una configurazione).
export const DEFAULT_REQUIRED = ["tipo", "data_sinistro", "cliente_presente"];
